import genericDataService from '@/services/genericDataService';

export const usePagination = {
  data() {
    return {
      pagesCounter: 1,
      currentPage: 1,
    };
  },
  methods: {
    async changePage(value, withoutSearchCallback) {
      if (!this.searchingParams) {
        return await this[withoutSearchCallback](value);
      }
      this.isLoadingNow = true;
      const currentParams = `${this.searchingParams}&page=${value}`;
      await genericDataService.searchManyParams(this.tableName, currentParams)
        .then((res) => {
          this.filteredRecords = res.data.records;
          this.usePagination(value, this.pagesCounter);
        })
        .finally(() => {
          this.isLoadingNow = false;
        });
    },
    usePagination(page = 1, pagesCounter, withScroll = true) {
      this.pagesCounter = pagesCounter;
      this.currentPage = page;
      if (withScroll) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/usePagination.js